import api from '../../services/api';
import Cookies from 'universal-cookie'
import { getConsultantIdentifier } from '../consultantUtils';
import ErrorService from '../../services/errorService';
import Swal from 'sweetalert2';
import { saveAs } from 'file-saver';
import { getFileNameFromHeader} from '../../Utilities/Utilities'


const data = {
    ElectronicSignature: {
        grupoDefensa: { estado: "No Enviado", enviado: false, message: "" },
        manual: { estado: "No Enviado", enviado: false, message: "" }
    },
};

const initialState = data;


const _endpoints = {
    ElectronicSignature: { get: "/V2/@Type/Get", post: "/V2/@Type/Send", put: "/V2/@Type/Upload", patch: "/V2/Estados/", delete: "/V2/@Type/Cancel" },
}


export default function firmaReducer(state = data, action) {
    switch (action.type) {
        case 'RESET':
            return initialState;
        case 'SET_FIELD_FIRMA': {
            return {
                ...state,
                ElectronicSignature: {
                    ...state.ElectronicSignature,
                    [normalizeString(action.signtype)]: action.payload
                }
            };
        }
        case 'FULL':
            return {...state, ElectronicSignature: action.payload}
        default:
            return state;
    }
};

export const setCargaDatosFirma = (actionKey, method, signType, data) => async (dispatch, getState) => {

    const consultantIdentifier = getConsultantIdentifier()
    if (!consultantIdentifier) {
        throw new Error('Consultor. Se debe de ingresar en el sistema es requerido su rut.');
    }
    return await dispatch(setFetchFirma(actionKey, method, _endpoints[actionKey]?.[method], data, signType, consultantIdentifier))
}


const setFetchFirma = (key, method, endpoint, data, signType, consultantIdentifier) => async (dispatch) => {
    const cookies = new Cookies();
    const headers = { 'Authorization': `Bearer ${cookies.get('tokenGcc')}` };

    data = data ?? "";
    const id = !isNaN(Number(data)) ? data : "";
    if (method != "patch")
        data.createBy = consultantIdentifier;
    endpoint = endpoint.replace("@Type", signType);
    const url = `${window.REACT_APP_GGC_API}/api/${key}${endpoint}${id}`;

    let queryString = '';

    // Si el método es GET, generamos los Query Parameters a partir del objeto 'data'
    if (method.toLowerCase() === "get") {
        queryString = objectToQueryString(data);
    }

    // Si el metodo es POST, agregamos el ud de abogado que esta atendiendo la entrevista
    if (method.toLowerCase() === "post") {
        data.IdSending = parseInt(cookies.get("userId"));
    }


    var response = null;

    try {
        /* METODOS */
        if (method === "post" && signType === "Manual") {
            // Descargar archivo si es firma manual
            response = await ErrorService.withTimeout(api.post(url, data, { headers, responseType: 'blob' }));
            if (response && response.status >= 200 && response.status < 300) {
                const file = new Blob([response.data], { type: response.headers['content-type'] });
                // Extraer nombre del archivo del header si existe
                const filename = getFileNameFromHeader(response.headers['content-disposition']);

                if (typeof saveAs === 'function') {
                    saveAs(file, filename);
                } else {
                    // Fallback nativo
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(file);
                    link.download = filename;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
                dispatch({
                    type: 'SET_FIELD_FIRMA', key, payload:
                    {
                        message: "Archivo descargado correctamente",
                        enviado: true,
                        estado: "Pendiente"
                    }
                    , signtype: signType
                });
                alertRedux("success", "Archivo descargado correctamente");
                return true;
            }
        } else {
            switch (method) {
                case "get":
                    const finalUrl = `${url}${queryString}`;
                    response = await ErrorService.withTimeout(api.get(`${finalUrl}`, { headers }));
                    break;
                case "post":
                    response = await ErrorService.withTimeout(api.post(url, data, { headers }));
                    break;
                case "put":
                    // Si data.Archivo es un FileList o array de archivos, usar FormData
                    if (data && data.Archivo && (Array.isArray(data.Archivo) || (typeof data.Archivo === 'object' && data.Archivo.length !== undefined))) {
                        const formData = new FormData();
                        // Convertir FileList a array si es necesario
                        const files = Array.from(data.Archivo);
                        files.forEach(file => {
                            formData.append('Archivo', file); // El nombre del campo debe coincidir con el esperado por la API
                        });
                        // Agregar otros campos
                        if (data.UserUpload) formData.append('UserUpload', data.UserUpload);
                        else formData.append('UserUpload', consultantIdentifier);
                        if (data.ContractId) formData.append('ContractId', data.ContractId);
                        if (data.Description) formData.append('Description', data.Description);
                        // Puedes agregar otros campos si lo necesitas
                        response = await ErrorService.withTimeout(api.put(url, formData, { headers: { ...headers, 'Content-Type': 'multipart/form-data' } }));
                    } else {
                        response = await ErrorService.withTimeout(api.put(url, data, { headers }));
                    }
                    break;
                case "patch":
                    response = await ErrorService.withTimeout(api.patch(url, data, { headers }));
                    break;
                case "delete":
                    const deleteUrl = `${window.REACT_APP_GGC_API}/api/${key}${endpoint}`;
                    response = await ErrorService.withTimeout(api.delete(deleteUrl, { headers, data }));
                    break;
                default:
                    alertRedux("warning", "Método no soportado");
                    return false;
            }
            if (response) {
                if (response.status >= 200 && response.status < 300) {
                    if (method == "patch") {
                        dispatch({ type: 'FULL', key, payload: response.data, signtype: signType });
                    } else
                        dispatch({ type: 'SET_FIELD_FIRMA', key, payload: response.data[normalizeString(signType)], signtype: signType });
                    var signResult = response.data.enviado;
                    if(method != "patch")
                    alertRedux(signResult === true ? "success" : "warning", response.data.message);
                    return true;
                }
            } else {
                alertRedux("danger", "Problema no identificado, al intentar conecetar con el servidor");
            }
        }
    } catch (error) {
        console.log(error);
        if (error.response?.status === 404) {
            alertRedux("warning", "ruta no encontrada, comuniquese con el proveedor");
        }
    }
    return false;
}

const alertRedux = (type, message) => {
    Swal.fire({
        title: message,
        icon: type,
        confirmButtonText: 'Entendido'
    });
};

export const resetActionFirma = () => async (dispatch, getState) =>
    dispatch({ type: 'RESET', payload: null });


//funcion privada para convertir un objeto en query string
const objectToQueryString = (data) => {
    // Si data no es un objeto (ej: es null, string o number), devolvemos cadena vacía.
    if (typeof data !== 'object' || data === null || Array.isArray(data)) {
        return '';
    }

    const params = Object.keys(data)
        .filter(key => data[key] !== undefined && data[key] !== null && data[key] !== '')
        .map(key => {
            return `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`;
        });

    // Si hay parámetros, los unimos con '&' y anteponemos '?'
    return params.length > 0 ? `?${params.join('&')}` : '';
};

const normalizeString = (str) => {
    if (typeof str !== 'string' || str.length === 0) return str;
    return str.charAt(0).toLowerCase() + str.slice(1);
}